import React, { useEffect } from 'react';

import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate } from 'react-router-dom';

import { pageTitles } from '@/constants/pageTitles';
import useFetch from '@/hooks/common/useFetch';
import useToast from '@/hooks/store/useToast';
import { type ProfileEditAuthState } from '@/interfaces/parent';

import EmailChangeForm from './EmailChangeForm';
import MyPageTemplate2 from './MyPageTemplate2';

interface EmailChangeTokenError {
  message: string;
}

const EmailChangePage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { showToast } = useToast();
  const { fetch, error } = useFetch<unknown, EmailChangeTokenError>(
    'POST',
    '/api/school/parents/email_change_tokens/create_without_additional_auth',
  );

  useEffect(() => {
    const state = location.state as ProfileEditAuthState | null;

    if (!state?.authenticated) {
      navigate('/mypage/profile', { replace: true });
      return;
    }
  }, [location.state, navigate]);

  const handleSubmit = (email: string) => {
    void fetch({ body: { email } }).then(({ status }) => {
      if (status >= 200 && status < 300) {
        navigate('/mypage/profile/email/change/sent', {
          state: {
            email,
            authenticated: true,
          },
        });
        showToast(`${email}にメールを送信しました`);
      }
    });
  };

  return (
    <MyPageTemplate2>
      <Helmet>
        <title>{pageTitles.mypage}</title>
      </Helmet>
      <EmailChangeForm onSubmit={handleSubmit} error={error} />
    </MyPageTemplate2>
  );
};

export default EmailChangePage;
